import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Search } from 'lucide-react';

import RestaurantSearch from './RestaurantSearch';
import LoaderSkeleton from './LoaderSkeleton';

const SearchSection = () => {
  const [isLoadingSkeleton, setIsLoadingSkeleton] = useState(false);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  
  const navigate = useNavigate();
  
  const handleNextClick = () => {
    setIsLoadingSkeleton(true);
    
    setTimeout(() => navigate('/confirmation', { state: { placeId: selectedRestaurant.id } }), 3000)
  };
  
  if (isLoadingSkeleton) {
    return <LoaderSkeleton/>
  }
  
  return (
    <div className="max-w-2xl mx-auto">
      <div className="card">
        <div className="text-center mb-6">
          <div className="flex justify-center mb-4">
            <div className="bg-primary-100 p-3 rounded-full">
              <Search className="w-8 h-8 text-primary-600"/>
            </div>
          </div>
          
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Find Your Restaurant
          </h3>
          
          <p className="text-gray-600">
            Enter your restaurant name to get started with your free reputation audit
          </p>
        </div>
        
        <RestaurantSearch selectedRestaurant={selectedRestaurant} setSelectedRestaurant={setSelectedRestaurant}/>
        
        <div className="mt-6">
          <button
            type="button"
            onClick={handleNextClick}
            disabled={!selectedRestaurant}
            className="btn-primary w-full disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            Next
          </button>
        </div>
        
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            Your report will include reputation score, NPS analysis, and review insights
          </p>
        </div>
      </div>
    </div>
  );
};

export default SearchSection;
